import { environment } from "src/environments/environment";

export class ConfigExtensions {

    static isProductionWithLimitedFeatures() {
        return environment.production && !environment.portalLive
    }
}